import { useAuthValue } from "context/AuthContext";
import { useState, useReducer } from "react";
import { useDispatch, useSelector } from "react-redux";
import {selectOrganization, showOrganization} from "store/actions/adminActions";
import { selectOrganizationSelected } from "store/selectors";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

export default function useHeader() {
    const { user } = useAuthValue();
    const [showOffCanvasSwitchAgency, setShowOffCanvasSwitchAgency] = useState(false);
    const [searchParams] = useSearchParams();
    const [showMenu, dispatchShowMenu] = useReducer((showMenu, action) => {
        return action === 'CLOSE' ? false : true;
    });
    const dispatch = useDispatch();
    const organizationFromRedux = useSelector(selectOrganizationSelected);

    let organizationSelected = user?.agent ? user?.agent?.getSelectedOrganization() : organizationFromRedux;

    if(!organizationSelected && searchParams.get('org_id')) {
        axios.get(`/organizations/${searchParams.get('org_id')}`)
            .then(response => {
                dispatch(selectOrganization(response.data));
            })
    }


    return {
        user,
        organizationSelected,
        showOffCanvasSwitchAgency, setShowOffCanvasSwitchAgency,
        showMenu, dispatchShowMenu
    }
}